import SearchBoxContainer from '@react/search/components/SeachBoxContainer';
import { SearchBoxSuggestion } from '@sly/core/api/types/search';
import { useCallback, useMemo } from 'react';
import { DynamicSearchProps } from 'sly/hubPage/components/HubDynamicContent/DynamicSearch/DynamicSearch.type';

const defaultList: string[] = [];

export default function DynamicSearch({
  title,
  toc,
  include: includeList,
  redirectLocation,
  placeholder,
  disableGoogleSearch,
}: DynamicSearchProps): JSX.Element | null {
  const include = useMemo(
    () => (includeList ?? defaultList).join(','),
    [includeList]
  );

  const onLocationSearch = useCallback(
    (suggestion: SearchBoxSuggestion) => {
      if (
        suggestion.resourceType === 'GoogleCity' ||
        suggestion.resourceType === 'City' ||
        suggestion.resourceType === 'Zipcode'
      ) {
        const redirect = redirectLocation ?? 'communities';
        if (redirect === 'communities') {
          window.location.href = suggestion.url;
        } else if (redirect === 'agents') {
          const [_x, _y, citySlug] = suggestion.url
            .replace(/^\//, '')
            .split(/[/?]/);

          const [_z, stateLong] = suggestion.displayText.split(', ');
          // zip codes have a whitespace after the state and before the zipcode
          const [stateShort] = stateLong.split(' ');

          window.location.href = `/agents/region/${citySlug}-${stateShort}`;
        }
      } else if (suggestion.action === 'redirect') {
        window.location.href = suggestion.url;
      }
    },
    [redirectLocation]
  );

  if (!title) {
    return null;
  }

  return (
    // border round?
    <div
      className='mb-l w-[calc(100%-2rem)] bg-viridian-lighter-90 p-l md:mb-xl md:w-[var(--col6)] md:p-xl lg:w-[var(--col8)]'
      data-tp-id='gen-div-ce8d573c-dcf5-44de-b78e-e91a360eec4a'
    >
      <div
        className='font-t-l mb-s md:mb-6'
        data-tp-id='gen-div-18482f8e-b556-4f8f-8129-90bcb097c5c9'
      >
        {title}
      </div>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*@ts-ignore*/}
      <SearchBoxContainer
        include={include}
        disableGoogleSearch={disableGoogleSearch}
        toc={toc}
        onLocationSearch={onLocationSearch}
        placeholder={placeholder ?? 'Search by city, state, zip'}
      />
    </div>
  );
}
